// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-5d718311]::-webkit-outer-spin-button,\ninput[data-v-5d718311]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-5d718311] {\n  -moz-appearance: textfield;\n}\n.custom-b-dropdown ul[data-v-5d718311], .custom-b-dropdown li[data-v-5d718311], .custom-b-dropdown a[data-v-5d718311], .custom-b-dropdown span[data-v-5d718311], .custom-b-dropdown div[data-v-5d718311] {\n  cursor: default !important;\n}", ""]);
// Exports
module.exports = exports;
